import React from "react";
import { Layout } from "../components/Layout";
import { useLanguage } from "../context/LanguageContext";
import { siteContent } from "../mock/rosablu.mock";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { MapPin, MapPinned } from "lucide-react";

export default function HomePage() {
  const { lang } = useLanguage();
  const hero = siteContent.hero[lang];
  const about = siteContent.about[lang];
  const suites = siteContent.suites[lang];

  return (
    <Layout>
      {/* HERO a tutta larghezza con immagine */}
      <section className="relative overflow-hidden bg-slate-900 text-slate-50">
  <div className="absolute inset-0">
    <img
      src="/images/rosablu/gallery/hero-casa3.webp"
      alt={
        lang === "it"
          ? "Casa e montagne in Val di Sole"
          : "House and mountains in Val di Sole"
      }
      width={1600}
      height={900}
      className="h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-black/45" />
  </div>
  <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 pb-20 pt-20 text-center md:pb-28 md:pt-24">
    <p className="mb-3 text-xs font-semibold uppercase tracking-[0.3em] text-slate-200">
      VAL DI SOLE · PIANO DI COMMEZZADURA
    </p>
    <h1 className="mb-4 font-serif text-3xl leading-tight text-white drop-shadow-[0_0_16px_rgba(0,0,0,0.65)] md:text-4xl lg:text-5xl">
      {hero.title}
    </h1>
    <p className="mb-6 max-w-2xl text-sm leading-relaxed text-slate-100/90 md:text-base">
      {hero.subtitle}
    </p>
    <div className="flex flex-wrap items-center justify-center gap-3">
      <Button
        className="rounded-full bg-[#b07157] px-7 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-white shadow-md hover:bg-[#975b45]"
        onClick={() => window.location.assign("/contatti")}
      >
        {hero.primaryCta}
      </Button>
      <Button
        variant="outline"
        className="rounded-full border-slate-200 bg-transparent px-7 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-50 hover:bg-slate-50/10"
        onClick={() => window.location.assign("/appartamento")}
      >
        {hero.secondaryCta}
      </Button>
    </div>
    <p className="mt-5 flex items-center justify-center gap-2 text-xs text-slate-200/90">
      <MapPin className="h-4 w-4" />
      {hero.note}
    </p>
  </div>
</section>


      {/* BLOCCO "CHE COS'È" */}
      <section className="bg-white pattern-home py-14 md:py-18">
        <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 md:flex-row md:items-start md:gap-12 md:px-6">
          <div className="md:w-1/2">
            <h2 className="mb-4 font-serif text-2xl text-slate-900 md:text-3xl">
              {lang === "it" ? "Che cos'è Rosa Blu Apartment?" : "What is Rosa Blu Apartment?"}
            </h2>
            <p className="mb-3 text-sm leading-relaxed text-slate-700 md:text-base">
              {about.intro}
            </p>
            <p className="mb-3 text-sm leading-relaxed text-slate-700 md:text-base">
              {about.body}
            </p>
            <p className="mb-3 text-sm leading-relaxed text-slate-700 md:text-base">
              {about.body2}
            </p>
            <p className="mt-2 text-sm font-medium text-slate-800 md:text-base">
              {about.highlight}
            </p>
          </div>
          <div className="md:w-1/2">
            <Card className="overflow-hidden rounded-3xl bg-[#f8f1e8] p-4 text-sm text-slate-800 shadow-sm">
              <img loading="lazy"
                src="/images/rosablu/gallery/camera4.webp"
                alt={lang === "it" ? "Camera di Rosa Blu Apartment" : "Rosa Blu Apartment bedroom"}
                className="mb-4 aspect-[4/3] w-full rounded-2xl object-cover"
              />
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                {lang === "it" ? "Un rifugio di luce e legno" : "A retreat of light and wood"}
              </p>
              <p className="mt-2 text-sm leading-relaxed text-slate-700">
                {lang === "it"
                  ? "Spazi raccolti, pensati principalmente per soggiorni di coppia, con materiali naturali e dettagli curati che richiamano l'atmosfera alpina."
                  : "Intimate spaces mainly designed for couples, with natural materials and curated details recalling the alpine atmosphere."}
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* BLOCCO APPARTAMENTO SINTETICO */}
      <section className="bg-[#f8f1e8] py-14 md:py-18">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <h2 className="font-serif text-2xl text-slate-900 drop-shadow-[0_0_12px_rgba(0,0,0,0.55)] md:text-3xl">
            {lang === "it" ? "Rosa Blu Apartment" : "Rosa Blu Apartment"}
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-700 md:text-base">
            {suites.subtitle}
          </p>
          <div className="mt-6 grid gap-6 md:grid-cols-2 md:items-stretch">
            <Card className="overflow-hidden rounded-3xl bg-[#f8f1e8] p-4 text-sm text-slate-800 shadow-sm">
              <img loading="lazy"
                src="/images/rosablu/gallery/cucina 18.webp"
                alt={lang === "it" ? "Camera matrimoniale di Rosa Blu Apartment" : "Rosa Blu Apartment bedroom"}
                className="mb-4 aspect-[4/3] w-full rounded-2xl object-cover"
              />
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                {lang === "it" ? "Appartamento" : "Apartment"}
              </p>
              <p className="mt-2 text-sm leading-relaxed text-slate-700">
                {lang === "it"
                  ? "Un unico appartamento curato nei dettagli, ideale come base tranquilla per scoprire la Val di Sole."
                  : "A single carefully curated apartment, an intimate base from which to explore Val di Sole."}
              </p>
            </Card>
            <Card className="flex flex-col justify-between rounded-3xl bg-white p-5 text-sm text-slate-800 shadow-sm">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                  {lang === "it" ? "Caratteristiche principali" : "Main features"}
                </p>
                <ul className="mt-3 space-y-2 text-sm leading-relaxed text-slate-700">
                  {suites.perks.slice(0, 4).map((item) => (
                    <li key={item} className="flex gap-2">
                      <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-[#b07157]" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-4 flex flex-wrap gap-3">
                <Button
                  className="rounded-full bg-[#b07157] px-6 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:bg-[#975b45]"
                  onClick={() => window.location.assign("/appartamento")}
                >
                  {lang === "it" ? "Vai alla pagina appartamento" : "Go to apartment page"}
                </Button>
                <Button
                  variant="outline"
                  className="rounded-full border-slate-400 bg-transparent px-6 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-800 hover:bg-slate-100"
                  onClick={() => window.location.assign("/contatti")}
                >
                  {lang === "it" ? "Richiedi disponibilità" : "Request availability"}
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </section>

      {/* BLOCCO VAL DI SOLE & ATTIVITÀ */}
      <section className="bg-white pattern-home py-14 md:py-18">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="grid gap-8 md:grid-cols-[1.5fr,1fr] md:items-center">
            <div>
              <h2 className="font-serif text-2xl text-slate-900 md:text-3xl">
                {lang === "it" ? "Val di Sole e attività" : "Val di Sole and activities"}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-700 md:text-base">
                {lang === "it"
                  ? "A pochi minuti da Rosa Blu Apartment si trova la stazione di Daolasa: punto di partenza per sci, snowboard, bike park, trekking ed escursioni panoramiche sulle Dolomiti di Brenta."
                  : "Just a few minutes from Rosa Blu Apartment you will find Daolasa station: the starting point for skiing, snowboarding, bike park, hiking and panoramic walks with Dolomiti di Brenta views."}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-700 md:text-base">
                {lang === "it"
                  ? "Dalla telecabina Daolasa-Val Mastellina raggiungi in poco tempo le piste della Skiarea Campiglio Dolomiti di Brenta e, in estate, i percorsi del famoso Bike Park Val di Sole."
                  : "From the Daolasa-Val Mastellina cable car you quickly reach the slopes of the Campiglio Dolomiti di Brenta ski area and, in summer, the trails of the renowned Val di Sole Bike Park."}
              </p>
              <Button
                className="mt-5 rounded-full bg-[#b07157] px-6 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:bg-[#975b45]"
                onClick={() => window.location.assign("/attivita")}
              >
                {lang === "it" ? "Scopri cosa puoi fare" : "Discover what to do"}
              </Button>
            </div>
            <Card className="overflow-hidden rounded-3xl bg-[#f8f1e8] p-4 text-sm text-slate-800 shadow-sm">
              <img loading="lazy"
                src="/images/rosablu/gallery/piste-sci.webp"
                alt={lang === "it" ? "Impianti sciistici" : "Ski lifts"}
                className="mb-4 h-56 w-full rounded-2xl object-cover"
              />
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                {lang === "it" ? "Sport in ogni stagione" : "Sports in every season"}
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* BLOCCO SERVIZI NELLE VICINANZE + PERCORSO BAR ROSA BLU */}
<section className="bg-[#f8f1e8] py-14 md:py-18">
  <div className="mx-auto max-w-6xl px-4 md:px-6 overflow-x-hidden">
    <div className="grid gap-8 md:grid-cols-2 md:items-center">
      <div className="min-w-0">
        <h2 className="font-serif text-2xl text-slate-900 md:text-3xl">
          {lang === "it" ? "Servizi a portata di mano" : "Nearby services"}
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-700 md:text-base break-words">
          {lang === "it"
            ? "Nel raggio di pochi minuti a piedi trovi tutto ciò che serve per una vacanza comoda: bar, ristoranti, negozi e servizi essenziali."
            : "Within a few minutes' walk you will find everything you need for a comfortable holiday: bars, restaurants, shops and essential services."}
        </p>
        <ul className="mt-4 space-y-2 text-sm leading-relaxed text-slate-700">
          <li className="flex gap-2">
            <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-[#b07157]" />
            <span>
              {lang === "it"
                ? "Bar Rosa Blu nelle vicinanze per colazioni, pause dolci, aperitivi e acquisti nel minimarket ben fornito."
                : "Nearby Rosa Blu Bar for breakfast, sweet breaks, aperitivo and a well-stocked minimarket."}
            </span>
          </li>
          <li className="flex gap-2">
            <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-[#b07157]" />
            <span>
              {lang === "it"
                ? "Negozi e servizi nel paese (minimarket aggiuntivi, noleggio attrezzatura, altri esercizi)."
                : "Shops and services in the village (additional groceries, equipment rental, other facilities)."}
            </span>
          </li>
          <li className="flex gap-2">
            <span className="mt-[6px] h-1.5 w-1.5 rounded-full bg-[#b07157]" />
            <span>
              {lang === "it"
                ? "Accesso comodo ai mezzi pubblici per muoversi lungo tutta la Val di Sole."
                : "Easy access to public transport to move along the whole Val di Sole."}
            </span>
          </li>
        </ul>
      </div>

      <Card className="flex min-w-0 flex-col justify-between rounded-3xl bg-white p-5 text-sm text-slate-800 shadow-sm">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
            {lang === "it" ? "Bar Rosa Blu" : "Rosa Blu Bar"}
          </p>
          <p className="mt-2 text-sm leading-relaxed text-slate-700 break-words">
            {lang === "it"
              ? "Si trova in Via Pietro Bernardelli 18, 38020 Commezzadura (TN): un punto di riferimento per colazioni, tabaccheria, ricevitoria, pacchi e spesa veloce."
              : "Located in Via Pietro Bernardelli 18, 38020 Commezzadura (TN): your reference for breakfast, tobacconist, parcel pick-up and quick groceries."}
          </p>
        </div>
     <div className="mt-4 flex flex-wrap gap-3">
  <Button
    variant="outline"
    className="inline-flex self-start items-center gap-2 rounded-full border-slate-400 bg-transparent px-4 py-2 text-[0.65rem] font-semibold uppercase tracking-[0.08em] text-slate-800 hover:bg-slate-100"
    onClick={() => window.open(siteContent.bar.location.directionsUrl, "_blank")}
  >
    <MapPinned className="h-4 w-4 flex-shrink-0" />
    <span className="px-1 text-center leading-snug break-words">
      {lang === "it"
        ? "Percorso da Rosa Blu al Bar Rosa Blu"
        : "Route from apartment to Rosa Blu Bar"}
    </span>
  </Button>
</div>
      </Card>
    </div>
  </div>
</section>
    </Layout>
  );
}
